export const isDevelopmentEnv = (): boolean => process.env.NODE_ENV === 'development';
